"use strict";
(function (global) {

  /**
   * Устанавливает часовой пояс пользователя.
   *
   * @tutorial services
   * @function WebAccess.services.userProfile.setTimeZone
   * @param {string} timeZoneId ИД часового пояса.
   * @return {Deferred} deferred-объект для управления отложенными вызовами.
   *
   * @example
   * // Установить часовой пояс для Екатеринбурга.
   * WA.SRV.userProfile.setTimeZone("Yekaterinburg Time");
   */
  global.userProfile.setTimeZone = function (timeZoneId) {
    return global.call('api/UserProfile.asmx/SetTimeZone', { 'timeZoneId': timeZoneId });
  };

})(window.WebAccess.services);